<template>
  <div class="newError">
    <navigator :items="items"></navigator>
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="container-fluid">
              <b-tabs card>
                <b-tab  title="Erro" active>
                <div class="row">
                  <div class="col-12">
                    <div class="form-group">
                      <label for>
                        Descrição
                        <span class="required-field">*</span>
                      </label>
                      <textarea v-model="error.error" type="text" class="form-control" />
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="form-group">
                      <label for>
                        Data do cadastro
                        <span class="required-field"></span>
                      </label>
                      <input v-model="dataCadastro" type="text" disabled class="form-control" />
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="form-group">
                      <label for>
                        Status
                        <span class="required-field">*</span>
                      </label>
                      <select class="form-control" v-model="error.status">
                        <option>{{"Pendente"}}</option>
                        <option>{{"Cancelada"}}</option>
                        <option>{{"Conclúida"}}</option>
                        <option>{{"Em Execução"}}</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12">
                    <button class="btn btn-primary float-right" v-on:click="save()">Salvar</button>
                  </div>
                </div>
              </b-tab>
              <b-tab title="Mensagens" :disabled="formType == 'create'">
                <list-messages :reported_error_id="id"></list-messages>
              </b-tab>
            </b-tabs>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "@/api/axios";
import ErrorValidate from "@/imports/validator/models/errors";
import validator from "@/imports/validator/validate";
import Swal from "sweetalert2";
import { bus } from "@/main";
import ListMessages from '@/components/errors/ListMessages'
import moment from "moment";

export default {
  name: "newError",
  props: {
    id: Number
  },
  components: {
    ListMessages
  },
  data() {
    return {
      tempFile: "",
      dataCadastro:"",
      formType: "create",
      error: {}, 
      items: [
        {
          text: "Erros e Melhorias",
          route: "admin.errors"
        },
        {
          text: "Novo Erro ou Melhoria",
          active: true
        }
      ],
    };
  },
  mounted() {
    this.getUserLogged();
    if(this.id)
    { 
          this.getDataObject(this.id);
    }else{
      this.dataCadastro = this.formatDate(new Date());
    }
  },
  methods: {
    getDataObject: function(id) {
      bus.$emit('changeLoading', true);
      axios
        .get(`${process.env.VUE_APP_API_HOST}/api/reported_error/${id}`)
        .then(response => {
          this.error = response.data;
          this.items[1].text = this.error.error;
          this.dataCadastro = this.formatDate(new Date(this.error.created_at));
          this.formType = "edit";
          bus.$emit('changeLoading', false);
        });
    },
    updateContent: function(val) {
      this.error.error = val;
    },
    getNow: function() {
        const today = new Date();
        const date = today.getDate() + '/'+(today.getMonth()+1)+'/'+today.getFullYear();
        this.dataCadastro = date;
    },
    uploadFile: function(e) {
      const file = e.target.files[0];
      if (!file.type.includes("image/") && !file.type.includes("/pdf")) {
        return;
      }
      if (typeof FileReader === "function") {
        const reader = new FileReader();
        reader.onload = event => {
          this.tempFile = event.target.result;
        };
        reader.readAsDataURL(file);
      }
    },
    getUserLogged: function(){
      let promise = axios.get(`${process.env.VUE_APP_API_HOST}/api/user_logged`)

      promise
          .then(response => {
            this.error.user_id = response.data.id;
           
          })
          .catch(error => {
            bus.$emit('changeLoading', false);
            Swal.fire({
              title: "Ocorreu um erro.",
              icon: "error"
            });
          });
    },
    save: function() {
      bus.$emit('changeLoading', true);
   
      let errors = validator.validate(this.error, ErrorValidate.model);
      
      if (errors.length == 0) {
        let promise =
          this.formType == "create"
            ? axios.post(`${process.env.VUE_APP_API_HOST}/api/reported_error`, this.error)
            : axios.put(
                `${process.env.VUE_APP_API_HOST}/api/reported_error/${this.error.id}`,
                this.error
              );

        promise
          .then(response => {
            bus.$emit('changeLoading', false);
            Swal.fire({
              title:
                this.formType == "create"
                  ? "Erro cadastrado"
                  : "Erro alterado com sucesso",
              icon: "success",
              onClose: () => {
                this.$router.push({ name: "admin.errors" });
              }
            });
          })
          .catch(error => {
            bus.$emit('changeLoading', false);
            Swal.fire({
              title: "Ocorreu um erro.",
              icon: "error"
            });
          });
      } else {
        bus.$emit('changeLoading', false);
        let html = "Preencha todos os campos obrigatórios.";
        if (errors.length < 4) {
          html = "";
          errors.forEach(el => (html += el.message + "<br>"));
        }
        Swal.fire({
          title: "Atenção",
          html: html,
          icon: "warning"
        });
      }
    },
    formatDate: function(date) {
      return moment(date).format("DD/MM/YYYY");
    }
  }
};
</script>

<style lang="scss">
@import "@/styles/General.scss";

.newError {
  .toggle-input {
    height: 37px;
    label {
      margin-bottom: 0 !important;
      margin-left: 5px;
    }
  }
  .card-header {
    background-color: white;
    a {
      text-decoration: none;
      color: $red_primary;
    }
  }
  .text-content{
    margin-top: 15px
  }
  .text-indice{
    background-color: $red_primary;
    width: fit-content;
    color: white;
    padding: 3px 10px;
    margin-bottom: 15px;
  }
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
